import React from 'react';
import PropTypes from 'prop-types';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormTextArea from 'components/dashboard/form/SMFormTextArea';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewPaymentPeriod extends React.Component {

  textAreaDidEndEditing(e) {
    this.props.delegate.changeBillingPeriodDescription(e.currentTarget.name, e.currentTarget.value);
  }

  render() {
    const reservation = this.props.reservation;
    const errors = this.props.errors;

    if (reservation.billing) {
      var period = reservation.billing.period ? I18n.l('date.ymd_slash', reservation.billing.period) : '';
      var periodDesc = reservation.billing.period_description;
    } else {
      var period = '';
      var periodDesc = '';
    }
    var period_description = [];
    if (this.props.isOwner) {
      period_description.push(
        <p className="mt20 mb10">変更理由</p>
      );
      period_description.push(
        <SMFormTextArea
          name="billing[period_description]"
          value={periodDesc}
          errorText={SMFormatHelper.errorText('Reservation', 'period_description', errors)}
          placeholderText="変更理由を記述"
          options={{
            className: 'form-textarea w500 h40',
            disabled: !SMReservationHelper.isPeriodExtendable(reservation)
          }}
          delegate={this} />
      );
    }

    return (
      <td>
        <SMFormTextField
          name="billing_period"
          value={period}
          options={{
            className: 'w110 js-datepicker',
            disabled: !SMReservationHelper.isPeriodExtendable(reservation)
          }}
          delegate={this} />
        <span
          className="message-important ml10">{SMFormatHelper.errorText('Reservation', 'billing.period_description', errors)}</span>

        {period_description}
      </td>
    );
  }
}

SMReservationEditViewPaymentPeriod.propTypes = {
  reservation: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  delegate: PropTypes.object
};
export default SMReservationEditViewPaymentPeriod;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewPaymentPeriod.jsx